import { Controller } from "@hotwired/stimulus";

export default class ContactFormFieldsController extends Controller {
  static targets = ["hiddenInput"];

  updateFieldState(event) {
    this.updateFieldStateFromRadio(event.target);
  }

  updateFieldStateFromRadio(radio) {
    const state = radio.value;
    const showAttr = radio.dataset.contactFormFieldsShowParam;
    const requiredAttr = radio.dataset.contactFormFieldsRequiredParam;

    let showValue, requiredValue;

    switch (state) {
      case "optional":
        showValue = "true";
        requiredValue = "false";
        break;
      case "required":
        showValue = "true";
        requiredValue = "true";
        break;
      case "disabled":
        showValue = "false";
        requiredValue = "false";
        break;
    }

    this.hiddenInputTargets.forEach((input) => {
      if (input.dataset.fieldName === showAttr) {
        input.value = showValue;
      }
      if (requiredAttr && input.dataset.fieldName === requiredAttr) {
        input.value = requiredValue;
      }
    });
  }
}
